document.addEventListener("DOMContentLoaded", function () {

  // Discount text logic
  const discountEl = document.querySelector(".discount-text");
  if (discountEl) {
    let text = discountEl.textContent.trim();
    let cleaned = text.replace(/^-+|\s*-+$/g, "").trim();

    const targets = document.querySelectorAll(".get-percentage-value");
    const targetsCard = document.querySelectorAll(".get-percentage-value-card");
    const targetsCTA = document.querySelectorAll(".cta-banner__btn");
    targets.forEach(el => {
      el.textContent = `GET ${cleaned}`;
    });
     targetsCTA.forEach(ctael => {
      ctael.textContent = `Buy Now — ${cleaned}`;
    });
    targetsCard.forEach(ell => {
      ell.innerHTML = `Buy Now — ${cleaned} 
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.05 2.90275L1.45425 12.5045C1.28042 12.6743 1.0805 12.7592 0.8545 12.7592C0.628666 12.7592 0.43075 12.6723 0.26075 12.4985C0.0869165 12.3245 0 12.1246 0 11.8988C0 11.6729 0.0869165 11.473 0.26075 11.299L9.8565 1.7035H1.4075C1.16317 1.7035 0.959166 1.62117 0.7955 1.4565C0.631833 1.292 0.55 1.08892 0.55 0.84725C0.55 0.60575 0.631833 0.404167 0.7955 0.2425C0.959166 0.0808336 1.16317 0 1.4075 0H11.9075C12.148 0 12.3501 0.0819171 12.5138 0.24575C12.6774 0.409417 12.7592 0.611417 12.7592 0.85175V11.3518C12.7592 11.5921 12.677 11.7941 12.5125 11.9578C12.348 12.1216 12.1449 12.2035 11.9033 12.2035C11.6576 12.2035 11.4539 12.1216 11.2923 11.9578C11.1308 11.7941 11.05 11.5921 11.05 11.3518V2.90275Z" fill="#AD71B1"></path>
      </svg>`;
    });
  }

  // Scroll 1
  const trigger1 = document.querySelector(".scroll-on-how-it-work-section");
  const target1 = document.querySelector(".product-card-experience-section-element");

  if (trigger1 && target1) {
    trigger1.addEventListener("click", function (e) {
      e.preventDefault();
      target1.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  // Scroll 2
const triggers = document.querySelectorAll(".scroll-on-product-section");
const target2 = document.querySelector(".new-featured-product-el");

if (target2) {
  triggers.forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      const offset = -100;
      const elementPosition = target2.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  });
}

  // Scroll 3 (multiple triggers)
  const triggers3 = document.querySelectorAll(
    ".card-button-type-see-real-reviews, .product__info-container .product__rating"
  );
  const target3 = document.querySelector(".new-testimonials-reviews-section");

  if (triggers3.length && target3) {
    triggers3.forEach(trigger => {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        target3.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

});




const mainATCButton = document.querySelector('.product-form__submit[type="submit"]');
const stickyATCButton = document.querySelector('.sticky-atc');
const topSection = document.querySelector('.new-featured-product-el');

if (mainATCButton && stickyATCButton && topSection) {
const handleStickyButtonVisibility = () => {
  const mainATCInView = isInViewport(mainATCButton);
  const topSectionInView = isInViewport(topSection);

  if (mainATCInView || topSectionInView) {
    stickyATCButton.style.display = 'none';
  } else {
    stickyATCButton.style.display = 'block';
  }
};

const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
};

window.addEventListener('scroll', handleStickyButtonVisibility);
window.addEventListener('load', handleStickyButtonVisibility);
window.addEventListener('resize', handleStickyButtonVisibility);
}